<template>
    <nav class="flex justify-between p-4">
      <div class="top-left-container">
        <img :src="require('@/assets/eventmocklogo.png')" alt="Illustration" class="logo">
    </div>
      <!-- <span class="text-sm text-gray-300">Powered by gravitee.io</span>-->
      <!--<button class="bg-transparent border border-gray-300 rounded-full px-4 py-1 text-gray-300">
        Menu
      </button>
    -->

    </nav>
  </template>
  
  <script>
  export default {
    name: "NavBar",
  };
  </script>
  
  <style scoped>
  /* Add any specific styles if needed */

  /* Container for the logo in the top-left */
.top-left-container {
  position: relative;
  top: 10px; /* Adjust spacing from the top */
  left: 10px; /* Adjust spacing from the left */
}

/* Styling for the logo */
.logo {
  width: 150px; /* Adjust size of the logo */
  height: auto;
}

  </style>
  